import { DialogTitle, DialogContent } from '@mui/material';
import DivisionEditor from '@pages/Events/DivisionEditor';

const WeightClassStep = () => {
    return (
        <>
            <DialogTitle>Divisions & Weight Classes</DialogTitle>
            <DialogContent sx={{ paddingX: 4 }}>
                <DivisionEditor />
            </DialogContent>
        </>
    );
};

export default WeightClassStep;
